import moment from 'moment'

import type { AggregateFeedConsumptionResult } from 'components/farm-dashboard/components/widgets/feed-consumption/types'

/** 7 дней данных (по дням) для превью FeedConsumptionLineChart и FeedConsumptionBarChart */
function buildMockFetchData(): AggregateFeedConsumptionResult['fetchData'] {
	const baseDate = moment(1709827200000).startOf('day')
	const fetchData: AggregateFeedConsumptionResult['fetchData'] = []

	for (let i = 0; i < 7; i++) {
		const date = baseDate.clone().add(i, 'days').valueOf()

		// Небольшие дневные изменения, без сильных «пил»,
		// больше похоже на пример с макета
		const distributed = 220 + [0, 8, -4, 10, -6, 5, -3][i]
		const cleaned = 130 + [2, -5, 9, -4, 6, -3, 1][i]

		fetchData.push({
			date,
			distributed_sum: distributed,
			cleaned_sum: cleaned,
			cattle_count: 120,
			psv: 85,
		})
	}

	return fetchData
}

const mockFetchData = buildMockFetchData()

export const FEED_CONSUMPTION_CHART_MOCK: AggregateFeedConsumptionResult = {
	fetchData: mockFetchData,
	distributedFood: Number(
		mockFetchData.reduce((s, p) => s + (p.distributed_sum ?? 0), 0).toFixed(0),
	),
	consumptionFood: Number(
		mockFetchData.reduce((s, p) => s + (p.cleaned_sum ?? 0), 0).toFixed(0),
	),
}
